<div class="tasks-list">
    <div class="header">
        <button class="back-button" (click)="back()">
        <img src="assets/icons/arrow-back.svg" width="24" height="24" [alt]="'common.back' | translate" />
        </button>
        <h2>{{ 'scheduler.title' | translate }}</h2>
    </div>
    <div class="empty-state" *ngIf="!tasks?.length">{{ 'scheduler.empty' | translate }}</div>

	<div class="task-card" *ngFor="let task of tasks; let i = index; trackBy: trackByTask" (click)="toggleExpand(task)">
		<div class="task-header">
			<span class="task-id">#{{ task.id }}</span>
			<span class="task-name-display">{{ task.name }}</span>
			<span class="task-hint">{{ 'common.click_to_expand' | translate }}</span>
		</div>

		<div class="task-details" *ngIf="isExpanded(task)" (click)="$event.stopPropagation()">
			<div class="header-grid">
				<div class="form-group">
					<label for="name">{{ 'scheduler.task_name' | translate }}</label>
					<input type="text" [(ngModel)]="task.name" />                    
				</div>
                <button class="remove-button" (click)="deleteTask(task); $event.stopPropagation()" [title]="'scheduler.delete_task' | translate">
                    <img src="assets/icons/close.svg" width="20" height="20" [alt]="'common.remove' | translate" />
                </button>
			</div>

            <div class="task-fields">
                <div class="form-group">
                    <label for="scheduler">{{ 'common.enabled' | translate }}</label>
                    <label class="switch">
                        <input type="checkbox" [(ngModel)]="task.enabled"/>
                        <span class="slider round"></span>
                    </label>

                    <label for="scheduler">{{ 'scheduler.done_today' | translate }}</label>
                    <label class="switch">
                        <input type="checkbox" [(ngModel)]="task.done"/>
                        <span class="slider round"></span>
                    </label>
                    
                    <label>{{ 'scheduler.time' | translate }}</label>
                    <!-- <input type="time"
                        [value]="(task.time !== undefined ? ((task.time/60) | number:'2.0-0')+':' + ((task.time%60)<10 ? '0'+(task.time%60) : (task.time%60)) : '')"
                        (change)="updateTaskTime(task, $any($event.target).value)"
                        style="width:120px;"/> -->
                    <!-- <input
                        type="time"
                        [value]="formatTime(task.time)"
                        (change)="updateTaskTime(task, $any($event.target).value)"
                        style="width:120px;"
                    />   -->
                    
                    <mat-form-field appearance="outline">
                        <input matInput
                                [ngxTimepicker]="picker"
                                [ngModel]="formatTime(task.time)"
                                [format]=24
                                (ngModelChange)="updateTaskTime(task, $event)">
                        <ngx-material-timepicker #picker [format]="24"/>                        
                    </mat-form-field>
            
                    <label>{{ 'scheduler.grace' | translate }}</label>
					<input type="number" [(ngModel)]="task.grace" />    
                    
                    <div class="task-dow">
                        <label for="scheduler">{{ 'scheduler.days_of_week' | translate }}</label>
                        <ng-container *ngFor="let day of [1,2,3,4,5,6,0]">
                            <label>
                                {{ dayNames[day] | translate }}
                    
                                <label class="switch">
                                    <input
                                        type="checkbox"
                                        [checked]="task.dow?.includes(day)"
                                        (change)="toggleDow(task, day)"
                                    />
                    
                                    <span class="slider round"></span>
                                </label>
                    
                            </label>


                            <!-- <label for="scheduler">{{ ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'][day] }}
                                <label class="switch">
                                    <input type="checkbox" [checked]="task.dow?.includes(day)" 
                                        (change)="toggleDow(task, day)"/>                                
                                    <span class="slider round"></span>                                
                                </label>
                            </label> -->
                        </ng-container>
                    </div>

                </div>
                
			</div>

			<div class="actions-container">
                <label for="scheduler">{{ 'scenario.actions' | translate }}</label>
                <div *ngFor="let action of task.actions; let j = index" 
                    class="action-card"
                    [class.deleting]="isDeleting(i, j)"
                    [class.adding]="isAdding(i, j)">
                    <div class="action-header">
                    <div class="action-controls-left">
                        
                    </div>
                    <button class="remove-button" (click)="removeAction(i, j)" [title]="'common.remove_action' | translate">
                        <img src="assets/icons/close.svg" width="20" height="20" [alt]="'common.remove' | translate" />
                    </button>
                    </div>
                    <div class="action-grid">
                        <div class="form-group">
                            <label>{{ 'common.type' | translate }}</label>
                            <select [(ngModel)]="action.type">
                            <option value="output">{{ 'common.output' | translate }}</option>
                            <option value="input">{{ 'common.input' | translate }}</option>
                            <option value="scenario">{{ 'common.scenario' | translate }}</option>
                            </select>
                        </div>

                        <div class="form-group" *ngIf="action.type === 'output'">
                            <label>{{ 'common.output' | translate }}</label>
                            <select [(ngModel)]="action.outputEid" >
                            <option *ngFor="let output of outputs" [ngValue]="output.eid">
                                {{ output.name }}
                            </option>
                            </select>
                        </div>

                        <div class="form-group" *ngIf="action.type === 'input'">
                            <label>{{ 'common.input' | translate }}</label>
                            <select [(ngModel)]="action.inputEid" >
                            <option *ngFor="let input of inputs" [ngValue]="input.eid">
                                {{ input.name }}
                            </option>
                            </select>
                        </div>

                        <div class="form-group" *ngIf="action.type === 'scenario'">
                            <label>{{ 'common.scenario' | translate }}</label>
                            <select [(ngModel)]="action.scenarioId">
                            <option *ngFor="let scenario of scenarios" [ngValue]="scenario.id">
                                {{ scenario.name }}
                            </option>
                            </select>
                        </div>

                        <div class="form-group" *ngIf="action.type === 'output'">
                            <label>{{ 'common.action' | translate }}</label>
                            <select [(ngModel)]="action.action">                  
                                <option value="on">{{ 'common.on' | translate }}</option>
                                <option value="off">{{ 'common.off' | translate }}</option>
                                <option value="toggle">{{ 'common.toggle' | translate }}</option>                  
                            </select>
                        </div>

                        <div class="form-group" *ngIf="action.type === 'input'">
                            <label>{{ 'scheduler.event' | translate }}</label>
                            <select [(ngModel)]="action.action">
                                <!-- <option [ngValue]="null">-- select event --</option> -->
                                <ng-container *ngFor="let inputItem of inputs">
                                    <ng-container *ngIf="inputItem.eid === action.inputEid">
                                        <option *ngFor="let event of inputItem.events"
                                            velue="event.event">{{ 'input.event.' + event.event | translate }}</option>
                                    </ng-container>
                                </ng-container>
                            </select>
                        </div>

                        <div class="form-group" *ngIf="action.type === 'scenario'">
                            <label>{{ 'common.action' | translate }}</label>
                            <select [(ngModel)]="action.action">                  
                                <option value="run">{{ 'common.run' | translate }}</option>
                                <option value="stop">{{ 'common.stop' | translate }}</option>                    
                            </select>
                        </div>
                    </div>
                </div>
                
                <button class="add-button" (click)="addAction(i)">
                <img src="assets/icons/plus.svg" width="20" height="20" [alt]="'common.add' | translate" />
                {{ 'common.add_action' | translate }}
                </button>
			
			</div>
		</div>
	</div>

    <div class="add-task">
        <button class="add-button" (click)="addTask()">
        <img src="assets/icons/plus.svg" width="20" height="20" [alt]="'common.add' | translate" />
        {{ 'scheduler.add_task' | translate }}
        </button>
    </div>

	<div class="actions">
		<button class="cancel-button" (click)="back()">{{ 'common.back' | translate }}</button>
		<button class="save-button" (click)="save()">{{ 'common.save' | translate }}</button>
	</div>
</div>
